// AtrWidget/AtrEngine.js
// Engine Pattern (rk=f03ae8b6) — extends EngineCleanupBase, singleton export.
// bootup+fetch() called from PageContent/BootRegistry at app boot (same as
// Sma200Engine/RollingRangeEngine). RMQ push handler ready for whenever a BE event
// exists (same pending-wiring situation as Sma200, rk=feb49f53a53946e99a16835e7ab545c4).
import EngineCleanupBase from '../../../services/engines/EngineCleanupBase';
import ComponentNotifier from '../../../services/wss/ComponentNotifier';
import atrCache from './AtrCache';
import atrFetcher from './AtrFetcher';

const _name = 'AtrEngine';

class AtrEngine extends EngineCleanupBase {
    bootup = () => {
        this.initialize(_name);
    };

    /**
     * Initial fetch for ALL assets (sid=0) — called once from PageContent alongside the
     * other engines' fetch/fetchAll calls.
     * @returns {Promise<void>}
     */
    fetch = async () => {
        try {
            const items = await atrFetcher.fetchAll();
            if (!items.length) return;

            atrCache.addOrUpdate(items);
            this._notify(null);
        } catch (error) {
            this.logError('fetch', error.message);
        }
    };

    /**
     * RMQ push handler. CacheBase2.addOrUpdate() requires an array (it calls
     * data.forEach) — wraps a bare single object into one.
     * @param {object|object[]} data
     */
    onAtrReceived = (data) => {
        try {
            const items = Array.isArray(data) ? data : [data];
            atrCache.addOrUpdate(items);
            this._notify(items[0]?.sid ?? null);
        } catch (error) {
            this.logError('onAtrReceived', error.message);
        }
    };

    /**
     * Today's ATR for one asset. rk = Sid, so a direct cache.get() is enough.
     * @param {number} sid
     * @returns {{per7:object,per14:object,per30:object,per60:object,per120:object,per200:object}|null}
     */
    getState = (sid) => atrCache.get(String(sid));

    /**
     * @param {number|null} sid - which asset changed, or null for a bulk refresh
     */
    _notify = (sid) => {
        ComponentNotifier.notify(_name, 'dataChanged', { sid });
    };
}

const atrEngine = new AtrEngine();
export default atrEngine;
